import React from 'react';
import {redirectToSecure} from '../../components/Authenticate/Authenticate';
import {LinearProgress} from "@material-ui/core";
import {getDashboard, getDashboardReset} from "../../actions";
import {connect} from 'react-redux';

const LoadingRoute = ({
    getDashboard,
    getDashboardReset,
    getDashboardSuccess
}) => {


    React.useEffect(() => {
        getDashboard();
    }, [getDashboard]);

    React.useEffect(() => {
        if (getDashboardSuccess) {
            redirectToSecure();
            getDashboardReset();
        }
    }, [getDashboardSuccess, getDashboardReset]);

    // Normal login
    return (
        <>
            <LinearProgress />
        </>
    );
}


export default connect(
    (state) => ({
        getDashboardSuccess: state.app.getDashboardSuccess
    }), {
        getDashboard,
        getDashboardReset
    }
)(LoadingRoute);
